import { triggerAPI, qs } from './modules/util';

const modalSection = qs('#paper-nach-modal');

qs('#paper-nach').addEventListener('submit', e => {
  e.preventDefault();
  // Setting Hubspot API
  let huspotPayload = {
    fields: [
      {
        name: 'firstname',
        value: `${qs('#name', modalSection).value}`
      },
      {
        name: 'phone',
        value: `${qs('#phone', modalSection).value}`
      },
      {
        name: 'email',
        value: `${qs('#email', modalSection).value}`
      },
      {
        name: 'company',
        value: `${qs('#company', modalSection).value}`
      },
      {
        name: 'number_physical_nach_mandate',
        value: `${qs('#nach-registrations-number', modalSection).value}`
      }
    ],
    context: {
      pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
      pageName: 'Paper Nach'
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text:
          'I agree to allow Example Company to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 6760497,
            text:
              'I agree to receive marketing communications from Example Company.'
          }
        ]
      }
    }
  };

  triggerAPI(
    'https://api.hsforms.com/submissions/v3/integration/submit/5558946/9b0c617b-bc59-442b-818a-d01d2e817774',
    'POST',
    response => {
      qs('.paper-nach-form', modalSection).style.display = 'none';
      qs('.after-success', modalSection).style.display = 'block';
    },
    huspotPayload
  );
});
